import styled from 'styled-components';
import { colors, toRgba, mixins } from '@/styles';

export const SelectCellCta = styled.div`
  text-align: center;
  table {
    max-width: 50%;
    width: 100%;
    border-collapse: collapse;
    td {
      border: 1px solid ${colors.secondary.lightGray3};
      width: 33%;
      height: 20px;
      &.selected {
        border-width: 3px;
      }
    }
  }
`;
